// eslint-disable-next-line import/no-unresolved
import { ActionPattern } from "@redux-saga/types";
import { Task } from "redux-saga";

import { IFilters } from "constants/filters";
import { IKeyValue } from "helpers/url";

export enum UrlQueryParamsView {
  Archives,
  Tickets,
  Reports,
}

export enum UpdateQueryTrigger {
  QueryParamsChange,
}

export interface IUrlQueryParamsFeatureRegisterViewPayload {
  view: UrlQueryParamsView;
  updateQueryActions?: string[];
  replaceHistoryActions?: ActionPattern;
  updateQueryTrigger?: UpdateQueryTrigger;
  shouldSetQueryParamsOnRegister?: boolean;
  isPathMatchingPattern?(pathname: string): boolean;
  // @ts-expect-error TS(7010): 'setQueryParamsAction', which lacks return-type an... Remove this comment to see the full error message
  setQueryParamsAction?(payload: { params: IKeyValue<string> });
  queryStringSerializer?(state: IWithViewQueryParams, pathname?: string): string;
  queryStringParser?(params: IKeyValue<string>, pathname?: string): IKeyValue<string>;
}

export interface IUrlQueryParamsFeatureUnregisterViewPayload {
  view: UrlQueryParamsView;
}

export interface IWithViewQueryParams {
  views: {
    archivesView?: {
      filters: IFilters;
      searchPhrase: string;
    };
    tickets?: {
      filters: IFilters;
    };
  };
}

export interface IViewRegistryItem {
  updateQueryActions?: ActionPattern;
  replaceHistoryActions?: ActionPattern;
  updateQueryTrigger?: UpdateQueryTrigger;
  updateUrlQueryParams: Task;
  isPathMatchingPattern?(pathname: string): boolean;
  // @ts-expect-error TS(7010): 'setQueryParamsAction', which lacks return-type an... Remove this comment to see the full error message
  setQueryParamsAction(payload: { params: IKeyValue<string> });
  queryStringSerializer(state: IWithViewQueryParams, pathname?: string): string;
  queryStringParser(params: IKeyValue<string>, pathname?: string): IKeyValue<string>;
}

export interface IViewRegistry {
  [key: string]: IViewRegistryItem;
}
